<template>
  <div>
    <!-- <v-snackbar
      v-model="alert"
      :color="alert_success"
      :timeout="timeout"
      icon="file_copy"
      dismissible
    >
      {{ alert_message }}
      <router-link
        style="padding-left:10px;"
        v-if="new_artist"
        :to="{
          name: 'EditArtist',
          params: { id: new_artist.id, artist: new_artist },
          path: `/artists/edit/${new_artist.id}`
        }"
      >
        <v-btn
          flat
          small
          icon
          @click="
            $router.push({
              params: { id: new_artist.id, artist: new_artist },
              path: `/artists/edit/${new_artist.id}`
            })
          "
        >
          <v-icon small>edit</v-icon>
        </v-btn>
      </router-link>
    </v-snackbar> -->

    <!-- <p>ownership {{s_ownership}}</p>
    <v-layout row wrap>
      <v-flex xs12 sm4 md4>
        <v-switch v-for="ownership in ownerships" 
          v-model="s_ownership"
          v-bind:value="ownership" 
          v-bind:label="ownership" 
          v-bind:key="ownership" hide-details>
        </v-switch>
      </v-flex>
    </v-layout>-->

    <v-card class="elevation-0 mx-3 py-0 my-0">
      <!-- <v-card class="mt-5 mx-2 elevation-0 white"> -->

      <v-card-title :class="{ black: add_new }">
        <!-- <v-btn :dark="!add_new" @click="add_new=!add_new" mr-3>Add New Artist</v-btn> -->
        <!-- <v-list> -->
        <transition name="fade" mode="out-in">
          <v-list-tile v-if="add_new == true">
            <v-layout row my-0 py-0 mr-3>
              <v-flex xs12 md3 my-0 py-0 mr-2>
                <v-text-field
                  color="white"
                  class="input-group dark mt-4 py-0"
                  dark
                  v-model="artist.first_name"
                  label="First Name"
                  value
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3 my-0 py-0 mr-2>
                <v-text-field
                  color="white"
                  class="input-group dark mt-4 py-0"
                  dark
                  v-model="artist.last_name"
                  label="Last Name"
                  value
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6 my-0 py-0>
                <v-text-field
                  color="white"
                  class="input-group dark mt-4 py-0"
                  dark
                  v-model="artist.name"
                  label="Name"
                  value
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-spacer></v-spacer>
            <v-btn
              outline
              color="green"
              :disabled="!artist.first_name.length > 0"
              @click="create_artist"
              >Save</v-btn
            >
            <v-btn outline color="white" @click="add_new = false">Cancel</v-btn>
          </v-list-tile>
        </transition>
        <!-- </v-list> -->
        <!-- <div class="text-xs-right">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon color="black" dark v-on="on" > <v-icon>sort</v-icon> </v-btn>
            </template>
            <v-list>
              <v-list-tile v-for="(item, index) in sortingItems" :key="index" @click="changeSort(item)" >
                <v-list-tile-title>{{ item }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>-->
      </v-card-title>

      <v-spacer></v-spacer>
      <!-- <p> {{s_ownership}}</p> -->
      <!-- {{ filtered.length }} - {{ s_ownership }} -->
      <!-- <v-btn-toggle v-model="s_ownership" class="mt-0" @change="toggleOwnership">
            <v-btn v-for="o in ownerships" flat :key="o.id" class="px-3" :input-value="o.id" :value="o.id" small>
              <span>{{o.name}}</span>
            </v-btn>
          </v-btn-toggle> -->

      <v-card-title
        class="mr-4 ml-2 pr-0 pb-0"
        style="position: fixed; top:130px; right:17px; background-color: #fff; opacity: 0.8;"
      >
        <v-spacer></v-spacer>
        <v-text-field
          v-if="this.$store.state.showSearch"
          style="background-color: #fff;"
          prepend-inner-icon="search"
          label="Search Artists "
          single-line
          hide-details
          clearable
          v-model="search"
        ></v-text-field>
      </v-card-title>

      <v-layout row my-3 ml-4>
        <span>
          <v-menu
            offset-y
            :close-on-content-click="true"
            class="text-xs-right mx-4 my-0 py-0 align-center"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                small
                icon
                color="black"
                dark
                v-on="on"
                class="text-xs-right mx-0 mt-2 my-0 py-0"
              >
                <v-icon small>supervisor_account</v-icon>
              </v-btn>
            </template>
            <v-list value="1">
              <v-list-tile
                v-for="(item, index) in ownerships"
                :key="index.id"
                @click="toggleOwnership(item)"
              >
                <!-- <v-list-tile-avatar v-if="item.id==sorting">
                  <v-icon>mdi-sort-ascending</v-icon>
                </v-list-tile-avatar> -->
                <!-- <v-list-tile-avatar v-else>
                  <v-icon></v-icon>
                </v-list-tile-avatar> -->
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </span>
        <span class="text-xs-left mt-2 pt-1 title">
          {{ selectedOwnership }}
        </span>
        <v-spacer></v-spacer>
      </v-layout>

      <!-- <v-card-title class="pl-4 pt-3">
      </v-card-title>-->

      <!-- prerobit pagination.sync na natahovanie zo settings -->
      <!-- style="border-top: 1px solid #eee" -->
      <v-data-table
        :pagination.sync="pagination2"
        :headers="headers"
        hide-headers
        :items="filtered"
        :search="search"
        v-model="selected"
        item-key="id"
        item-value="last_name"
        must-sort
        ref="dTable"
        expand
        :expanded="filtered"
        rows-per-page-text="Artists per page"
        no-results-text="No Artists match the criteria."
        class="elevation-0 mx-4"
      >
        <!-- select-all 
        @change="save_currently_selected_all(selected)"-->
        <template slot="items" slot-scope="props">
          <tr
            style="border-top: #eee solid 1px;"
            :class="{ black: props.expanded, 'white--text': props.expanded }"
          >
            <td class="mx-0 px-0">
              <!-- <table class="mb-3">
                <tr class="my-0 py-0"> -->
              <!-- <td style="width:20px;" class="mx-0 px-0">
                    <v-checkbox color='black' hide-details
                      v-model="props.selected"
                      @change="save_currently_selected(props.selected,props.item)"
                    ></v-checkbox>
                  </td>-->
              <!-- <td
                    colspan="3"
                    style="border-bottom: 1px black solid; margin-bottom: 0px !important; padding-bottom:0px !important; height: 38px;"
                  > -->
              <v-flex class="layout pt-2 pr-0">
                <router-link
                  :class="{
                    black: props.expanded,
                    'white--text': props.expanded
                  }"
                  class="title pt-2 font-weight-light mx-1"
                  :to="{
                    name: 'EditArtist',
                    params: { id: props.item.id, artist: props.item },
                    path: `/artists/edit/${props.item.id}`
                  }"
                  v-html="props.item.name"
                ></router-link>
                <v-spacer></v-spacer>
                <!-- <v-btn small icon @click="props.expanded = !props.expanded" class="mt-0 pt-0"><v-icon small dark>more_vert</v-icon></v-btn> -->
                <v-btn icon small @click="props.expanded = !props.expanded">
                  <v-icon
                    v-if="!props.expanded"
                    :class="{ 'white--text': props.expanded }"
                    >expand_more</v-icon
                  >
                  <v-icon
                    v-if="props.expanded"
                    :class="{ 'white--text': props.expanded }"
                    >expand_less</v-icon
                  >
                </v-btn>
              </v-flex>

              <!-- - - - - - First: {{props.item.first_name}} - - - - - Last: {{props.item.last_name}} - - - - - Sort: {{props.item.sort_name}} -->
            </td>
          </tr>
        </template>

        <template v-slot:expand="props" :class="{ inverted: props.expanded }">
          <!-- <tr v-if="showMore"> -->
          <!-- <td colspan="3"> -->
          <view-artworks
            :artist="props.item"
            class="mx-3 py-0 my-0"
          ></view-artworks>
          <!-- style="width:99% !important;" -->
          <!-- </td>
                </tr> -->
          <!-- </table>
            </td> -->
          <!-- <td style='width:50px;'>
            <v-layout flex>-->
          <!-- <v-icon v-if="props.item.collective=='1'" class="hidden-sm-and-down person">people</v-icon>
            <v-icon v-if="props.item.collective!='1'" class="hidden-sm-and-down person">person</v-icon>-->
          <!-- <router-link style="padding-left:10px;" -->
          <!-- :to="{ name: 'EditArtist', params: {id: props.item.id, artist: props.item}, path: `/artists/edit/${props.item.id}`}" > -->
          <!-- <v-btn flat small icon @click="$router.push({params: {id: props.item.id, artist: props.item}, path: `/artists/edit/${props.item.id}`})"><v-icon small>edit</v-icon></v-btn> -->
          <!-- </router-link> -->
          <!-- <v-btn flat small icon @click="duplicateArtwork(props.item.id)"><v-icon small>file_copy</v-icon></v-btn> -->
          <!-- </v-layout>
            </td>-->
          <!-- <td>
              <router-link style="padding-left:10px;" class="title"
                :to="{ name: 'EditArtist', params: {id: props.item.id, artist: props.item}, path: `/artists/edit/${props.item.id}`}" >
                {{ props.item.first_name }}
              </router-link>
            </td>
            <td>
              <router-link style="padding-left:10px;" class="title"
                :to="{ name: 'EditArtist', params: {id: props.item.id, artist: props.item}, path: `/artists/edit/${props.item.id}`}" >
                {{ props.item.last_name }}
              </router-link>
            </td>-->
          <!-- </tr>
            <tr>-->
          <!-- <td style='width:10%;' > -->
          <!-- <router-link style="padding-left:10px;" class="title"
                :to="{ name: 'EditArtist', params: {id: props.item.id, artist: props.item}, path: `/artists/edit/${props.item.id}`}" >
                {{ props.item.name }}
            </router-link>-->
          <!-- </td> -->
          <!-- <td>
              <router-link style="padding-left:10px;"
                :to="{ name: 'EditArtist', params: {id: props.item.id, artist: props.item}, path: `/artists/edit/${props.item.id}`}" >
                {{ props.item.company }}
              </router-link>
            </td>-->
          <!-- <td>
            <view-artworks :artist="props.item" style='width:500px !important;'></view-artworks>-->
          <!-- <v-chip v-for="artwork in artist_artworks(props.item.id)" v-bind:key="artwork.id" small >{{artwork.title}}</v-chip> -->
          <!-- </td> -->
          <!-- </tr> -->
        </template>
        <v-divider></v-divider>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from '../../../static/axios.js'
import Artist from '@/components/artists/Artist.vue'
import EditArtist from '@/components/artists/EditArtist.vue'
import ViewArtworks from '@/components/artists/ViewArtworks.vue'
import { serverBus } from '../../main'

export default {
  data: () => ({
    selectedOwnership: '',
    showMore: false,
    ownerships: [],
    s_ownership: 1,
    show_add_artist_form: false,
    pagination2: {
      rowsPerPage: 15,
      sortBy: 'first_name'
    },
    artist: {
      name: '',
      first_name: '',
      last_name: ''
    },
    // sortingItems: [ 'name', 'first_name', 'last_name' ],
    alert: false,
    alert_message: '',
    alert_success: '',
    // color: "",
    mode: '',
    timeout: 10000,
    selected: [],
    filtered: [],
    artists: [],
    results: [],
    editArtist: false,
    new_artist: {},
    search: '',
    headers: [
      // { text: '', align: 'left', sortable: false },
      { text: 'First Name', value: 'first_name', align: 'left' },
      { text: 'Last Name', value: 'last_name', align: 'left' },
      { text: '', value: 'sort_name', align: 'center' },
      { text: 'Name', value: 'name', align: 'left' }
      // { text: 'Collective Name', value: 'collective', align: 'left' },
      // { text: 'Company', value: 'company', align: 'left' },
      // { text: 'Artworks', sortable: false }
    ]
  }),
  mounted() {
    if (this.c_user.expand_artist_artworks) {
      for (let i = 0; i < this.filtered.length; i += 1) {
        const item = this.filtered[i]
        this.$set(this.$refs.dTable.expanded, item.id, true)
      }
    }
  },
  created: function() {
    // this.getArtists()
    this.ownerships = Object.assign([], this.$store.getters.my_ownerships)
    this.ownerships.unshift({ id: 'all', name: 'All' })
    this.initialize()
    this.filtered = this.artists
    serverBus.$on('setSorting', a => {
      // console.log('receive')
      // console.log(a)
      this.pagination2.sortBy = a
      this.pagination2.descending = !this.pagination2.descending
    })
    this.toggleOwnership(
      this.$store.state.filters['artists']
        ? this.$store.state.filters['artists']
        : this.ownerships[0]
    )
  },
  methods: {
    toggleOwnership(o) {
      // var array = [];
      // for (var i in ownerships) {
      //   // array.push(i);
      //   array.push(ownerships[i]);
      // }
      // console.log(array);
      // console.log(this.ownerships);
      // console.log(array.indexOf(this.s_ownership));
      // console.log(this.s_ownership);
      // console.log(this.ownerships.indexOf(this.s_ownership));
      this.selectedOwnership = o.name
      this.$store.dispatch('setFilter', { section: 'artists', ownership: o })
      if (o.id != 'all') {
        this.filtered = this.artists.filter(a =>
          this.$store.state.artworks.some(
            ar => ar.artist_id == a.id && ar.ownership == o.id
          )
        )
      } else {
        this.filtered = this.artists
      }
    },
    create_artist() {
      // if (this.$refs.form.validate()) {
      // console.log(this.artwork)
      let url = `${this.$globals.apiserver}/artists.json`
      // console.log(url)
      this.artist.created_by = this.c_user.id
      axios
        .post(url, this.artist)
        .then(response => {
          // this.loading = false;
          // console.log(response.data)
          this.result = response.data
          this.artist = response.data
          this.$store.dispatch('addArtist', response.data)
          // this.artwork = response.data
          // this.artist = response.data.artist
          // this.e1 = 3
          // console.log(this.artwork)
          this.$router.push({
            name: 'EditArtist',
            // path: `/artists/edit/${this.artist.id}`,
            params: { id: this.artist.id, artist: this.artist }
          })
        })
        .catch(error => {
          // console.log(error)
        })
      // }
    },
    // create_artist () {},
    initialize() {
      this.artists = Object.assign([], this.$store.state.artists)
      this.$store.dispatch('loadArtists')
    },
    duplicateArtwork(id) {
      let url = `${this.$globals.apiserver}/artists/duplicate/${id}.json`
      axios
        .get(url)
        .then(response => {
          // console.log(response.data);
          this.new_artist = response.data
          // this.results.push(response.data)
          this.artists.push(response.data)
          this.$store.dispatch('addArtist', response.data)
          this.alert = true
          this.alert_message = 'Creating duplicate successfull.'
          this.alert_success = 'success'
          this.artists = this.artists.sort(function(a, b) {
            return b.first_name - a.first_name
          })
        })
        .catch(error => {
          // console.log(error)
          this.alert = true
          this.alert_message = 'Creating duplicate failed.'
          this.alert_success = 'error'
        })
    },
    _toggle() {
      this.editArtist = true
    },
    reverseMessage: function() {
      this.artist.name = this.artist.name
        .split('')
        .reverse()
        .join('')
    },
    getArtists() {
      this.results = Object.assign([], this.$store.state.artists)
      // console.log('test output getPosts')
      // let url = 'http://www.tb-cms.org/artists.json?artists=artists'
      // console.log(url)
      // axios.get(url).then((response) => {
      // this.loading = false;
      // this.results = response.data
      // }).catch((error) => { console.log(error) })
    },
    clear_selection() {
      this.$store.dispatch('clearCurrentSelection')
      this.selected = []
    },
    select_all() {},
    save_currently_selected(a, b) {
      // console.log('///////////')
      // console.log('a = ' + a)
      // console.log('b = ' + b.id)
      setTimeout(
        function() {
          var temp_selection = Object.assign(
            [],
            this.$store.state.currentSelection
          )
          //// console.log(temp_selection)
          if (!a) {
            // console.log('a true')
            if (!temp_selection.includes(b)) {
              // console.log('doesnt include')
              temp_selection.push(b)
            }
          } else {
            // console.log('false')
            var index = temp_selection.indexOf(b)
            // console.log('index = ' + index)
            temp_selection.splice(index, 1)
          }
          // this.$store.state.currentSelection
          // console.log(temp_selection)
          // this.selected.forEach(s => {
          //   if (!temp_selection.includes(s)) {
          //     temp_selection.push(s)
          //   }
          // })
          // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
          this.$store.dispatch('saveCurrentSelection', temp_selection)
        }.bind(this),
        1000
      )
    },
    save_currently_selected_all(a) {
      // console.log('///////////')
      // console.log('a = ' + a)
      var temp_selection = Object.assign([], this.$store.state.currentSelection)
      // console.log(temp_selection)
      if (!a) {
        // console.log('a true')
        if (!temp_selection.includes(b)) {
          // console.log('doesnt include')
          temp_selection.push(b)
        }
      } else {
        // console.log('false')
        var index = temp_selection.indexOf(b)
        // console.log('index = ' + index)
        temp_selection.splice(index, 1)
      }
      // this.$store.state.currentSelection
      // console.log(temp_selection)
      // this.selected.forEach(s => {
      //   if (!temp_selection.includes(s)) {
      //     temp_selection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', temp_selection)
    },
    save_currently_selected_tags() {
      this.$store.dispatch('saveCurrentSelectionTags', this.selected_tags)
      this.ta = this.tagged_artworks
    }
  },
  computed: {
    // pagination2 () {
    //   var pagination2 = { rowsPerPage: 10, sortBy: "last_name" }
    //   return pagination2
    //   // get () {
    //   //   // console.log('sssssss')
    //   //   // console.log(this.$store.state.sorting['artists'])
    //   //   // console.log('artistsssss')
    //   //   // { rowsPerPage: 10, sortBy: 'last_name' }
    //   //   // return { rowsPerPage: 10, sortBy: (this.$store.state.sorting['artists'] ? this.$store.state.sorting['artists'] : 'last_name') }
    //   // },
    //   // set (value) {
    //   //   // this.$store.dispatch('setSorting', value)
    //   //   this.$store.dispatch('setSorting', { sorting: {column: this.sorting.sortBy, section: 'artists' }})

    //   // }
    // },
    add_new: {
      get() {
        return this.$store.state.add_new
      },
      set(value) {
        this.$store.dispatch('addNew', value)
      }
    },
    processedArtists() {
      let artists = this.results
      this.artists.map(artist => {
        let a = artist
        artist.first_name = a ? a.first_name : 'nema meno'
      })
      // console.log(artists)
      return artists
    }
  },
  filters: {
    capitalize: function(a) {
      if (!a) return ''
      a = a.toString()
      return a.charAt(0).toUpperCase() + a.slice(1)
    }
  },
  components: {
    Artist,
    EditArtist,
    ViewArtworks
  }
}
</script>

<style scoped>
table {
  table-layout: fixed !important;
  width: 100%;
}
table.v-table thead td:not(:nth-child(1)),
table.v-table tbody td:not(:nth-child(1)),
table.v-table thead th:not(:nth-child(1)),
table.v-table tbody th:not(:nth-child(1)),
table.v-table thead td:first-child,
table.v-table tbody td:first-child,
table.v-table thead th:first-child,
table.v-table tbody th:first-child {
  padding: 0 5px 0 5px !important;
}
/*a {
  color: #fff !important;
  text-decoration: none;
}
/* a:hover {
  border-bottom: 1px solid black;
} */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
table.v-table thead td[data-v-69e20289]:not(:nth-child(1)),
table.v-table tbody td[data-v-69e20289]:not(:nth-child(1)),
table.v-table thead th[data-v-69e20289]:not(:nth-child(1)),
table.v-table tbody th[data-v-69e20289]:not(:nth-child(1)),
table.v-table thead td[data-v-69e20289]:first-child,
table.v-table tbody td[data-v-69e20289]:first-child,
table.v-table thead th[data-v-69e20289]:first-child,
table.v-table tbody th[data-v-69e20289]:first-child {
  padding: 0px !important;
}
/* .inverted { background-color: #000; } */
</style>



// WEBPACK FOOTER //
// src/components/artists/Artists.vue